export default __webpack_public_path__ + "static/media/rizee_bs.4fc4b628.png";